/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import './ActionRequiredViewer.css';
import CustomEditCard from '../../../common/components/CustomEditCard/CustomEditCard';
import SearchComponent from '../../../common/components/SearchComponent';
import YearFilterButton from '../../../common/components/YearFilterButton/YearFilterButton';
import TwoDatesFilter from '../../../common/components/TwoDatesFilter/TwoDatesFilter';
import LeavesTable from '../../../common/components/ActionRequiredTables/LeavesTable';
import LeaveAdvanceEncashment from '../../../common/components/ActionRequiredTables/LeaveAdvanceEncashment';
import Promotions from '../../../common/components/ActionRequiredTables/Promotions';
import Award from '../../../common/components/ActionRequiredTables/Award';
import SwapShift from '../../../common/components/ActionRequiredTables/SwapShift';
import Transfer from '../../../common/components/ActionRequiredTables/Transfer';
import Resignation from '../../../common/components/ActionRequiredTables/Resignation';
import Termination from '../../../common/components/ActionRequiredTables/Termination';
import Warning from '../../../common/components/ActionRequiredTables/Warning';
import Complaint from '../../../common/components/ActionRequiredTables/Complaint';
import EmployeeTicket from '../../../common/components/ActionRequiredTables/EmployeeTicket';
import Claims from '../../../common/components/ActionRequiredTables/Claims';
import OffCycle from '../../../common/components/ActionRequiredTables/OffCycle';
import RecurringPayment from '../../../common/components/ActionRequiredTables/RecurringPayment';
import SalaryAdjustment from '../../../common/components/ActionRequiredTables/SalaryAdjustment';
import SetSalary from '../../../common/components/ActionRequiredTables/SetSalary';
import GovtTax from '../../../common/components/ActionRequiredTables/GovtTax';
import FnF from '../../../common/components/ActionRequiredTables/FnF';
import Overtime from '../../../common/components/ActionRequiredTables/Overtime';
import PayrollSettlement from '../../../common/components/ActionRequiredTables/PayrollSettlement';
import TransferReceive from '../../../common/components/ActionRequiredTables/TransferReceive';
import CustomAutoComplete from '../../../common/components/CustomAutoComplete/CustomAutoComplete';
import { useTranslate } from '../../../hooks';
import LetterRequest from '../../../common/components/ActionRequiredTables/LetterRequest';
import CompOff from '../../../common/components/ActionRequiredTables/CompOff';

interface propsType {
  isLoading?: boolean;
  trans?: any;
  i18n?: any;
  all_menus?: any;
  arVal?: string;
  handleSearchFilter?: any;
  actionRequiredEventName?: any;
  allDepartments?: any;
  handleSelectedDeptId?: any;
  leaveType?: any;
  handleSelctedLeaveTypeId?: any;
  title?: any;
}

const ActionRequiredMenusPresenter: React.FC<propsType> = ({
  trans,
  arVal,
  handleSearchFilter,
  actionRequiredEventName,
  allDepartments,
  handleSelectedDeptId,
  leaveType,
  handleSelctedLeaveTypeId,
  title,
}) => {
  const { translate } = useTranslate();

  return (
    <CustomEditCard
      card_title={''}
      card_height="65vh"
      maxHeightForScroll={'62vh'}
      showEditButton={false}
    >
      <Grid container spacing={2}>
        <Grid item flex={1}>
          <Typography>{arVal ? translate(arVal) : ''}</Typography>
        </Grid>
        <Grid item>
          <SearchComponent onChange={(c: any) => handleSearchFilter(c)} />
        </Grid>

        <Grid item>
          <TwoDatesFilter />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {arVal == 'Leave and Leave Advance' && <LeavesTable trans={trans} />}
        {arVal == 'Leave Encashment' && (<LeaveAdvanceEncashment trans={trans} />)}
        {arVal == 'Promotions' && <Promotions trans={trans} />}
        {arVal == 'Award' && <Award trans={trans} />}
        {arVal == 'Swap Shift' && <SwapShift trans={trans} />}
        {arVal == 'Transfer' && <Transfer trans={trans} />}
        {arVal == 'Resignation' && <Resignation trans={trans} />}
        {arVal == 'Termination' && <Termination trans={trans} />}
        {arVal == 'Warning' && <Warning trans={trans} />}
        {arVal == 'Complaint' && <Complaint trans={trans} />}
        {arVal == 'Employee Ticket' && <EmployeeTicket trans={trans} />}
        {arVal == 'Claims' && <Claims trans={trans} />}
        {arVal == 'Off-Cycle' && <OffCycle trans={trans} />}
        {arVal == 'Recurring Payment' && <RecurringPayment trans={trans} />}
        {arVal == 'Salary Adjustment' && <SalaryAdjustment trans={trans} />}
        {arVal == 'Set Salary' && <SetSalary trans={trans} />}
        {arVal == 'Government Tax' && <GovtTax trans={trans} />}
        {arVal == 'FnF' && <FnF trans={trans} />}
        {arVal == 'Overtime' && <Overtime trans={trans} />}
        {arVal == 'Payroll Settlement' && <PayrollSettlement trans={trans} />}
        {arVal == 'Transfer Receive' && <TransferReceive trans={trans} />}
        {arVal == 'Letter Request' && <LetterRequest trans={trans} />}
        {arVal == 'Comp Off' && <CompOff trans={trans} />}
      </Grid>
    </CustomEditCard>
  );
};

export default ActionRequiredMenusPresenter;
